import { ListPlus, Loader2, Radio, Square } from "lucide-react";
import { wholeStory } from "@/lib/storyRead";

const pill = "inline-flex min-h-[24px] shrink-0 items-center gap-1 rounded-full border border-white/15 px-2 text-[11px] text-ink-soft align-middle transition-colors hover:border-brand/50 hover:text-brand";

// The small Listen button that sits beside a headline in a list.
export const ListenLine = ({ story, speaker, lang = "", testid, onQueue, queued = false }) => {
  const key = `${story.story_id || story.alert_id}-read`;
  const busy = speaker.loading === key;
  const reading = speaker.playing === key;

  return (
    <>
      <button
        data-testid={testid || `listen-line-${story.story_id || story.alert_id}`}
        onClick={() => speaker.play(key, wholeStory(story, lang), story.title)}
        title="Let MiLu tell you the whole story"
        className={`ms-2 ${pill} ${reading || busy ? "border-brand/60 text-brand" : ""}`}
      >
        {busy ? <Loader2 className="h-3 w-3 animate-spin" />
          : reading ? <Square className="h-3 w-3 text-brand" />
          : <Radio className="h-3 w-3 text-brand" />}
        {busy ? "Getting it…" : reading ? "Stop" : "Listen"}
      </button>
      {onQueue && (
        <button
          data-testid={`queue-add-${story.story_id || story.alert_id}`}
          onClick={() => onQueue(story)}
          title="Line it up to listen later"
          className={`ms-1 ${pill} ${queued ? "border-brand/60 text-brand" : ""}`}
        >
          <ListPlus className="h-3 w-3" /> {queued ? "Queued" : "Queue"}
        </button>
      )}
    </>
  );
};
